import Reveal from "./Reveal";

export default function SectionHeading({ eyebrow, title, description, dark = false, align = "left" }) {
    const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
    return (
        <div className={`flex flex-col gap-4 ${alignCls}`}>
            {eyebrow && (
                <Reveal>
                    <span className="eyebrow inline-flex items-center gap-2">
                        <span className="inline-block h-px w-8 bg-coral" aria-hidden="true" />
                        {eyebrow}
                    </span>
                </Reveal>
            )}
            <Reveal delay={0.08}>
                <h2
                    className={`max-w-2xl font-serif text-3xl font-bold leading-[1.12] tracking-tight sm:text-4xl lg:text-5xl ${
                        dark ? "text-cream" : "text-forest"
                    }`}
                >
                    {title}
                </h2>
            </Reveal>
            {description && (
                <Reveal delay={0.16}>
                    <p className={`max-w-xl text-sm sm:text-base ${dark ? "text-cream/70" : "text-graphite-muted"}`}>
                        {description}
                    </p>
                </Reveal>
            )}
        </div>
    );
}
